














import { Component, Prop, Vue } from "vue-property-decorator";
import { Policies } from "@/lib/Policies";

@Component({
  components: {},
})
export default class PoliciesComponent extends Vue {
  @Prop({ required: true })
  public model!: Policies;
}
